import { generateDeferredPromise } from '@utils/DeferredPomiseUtil'

declare let cordova: any

export async function executeCordovaCallListener (message: any) {
    const deferred = generateDeferredPromise<any>()

    console.info('ATBase: Received request for cordova call with message: ' + JSON.stringify(message))
    cordova.exec(
        deferred.resolve,
        deferred.reject,
        message.data.plugin,
        message.data.action,
        message.data.args,
    )

    return deferred.promise
}
